import { z } from "zod";

export const connectDevicesToProviderRequestPayloadSchema = z.object({
  data: z.array(
    z.object({
      vehicleUuid: z.uuid(),
      vin: z.string(),
      registrationNumber: z.string(),
      companyUuid: z.uuid(),
      departmentUuid: z.uuid().nullable(),
      deviceId: z.string(),
      brand: z.string(),
      updatedBy: z.string(),
    }),
  ),
});

export type ConnectDevicesToProviderRequestPayload = z.infer<
  typeof connectDevicesToProviderRequestPayloadSchema
>;
